// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskCurrencyBr {
  public iconMask() {
    return 'svg-icon-currency';
  }

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    let shiftedValue = newValue.replace(/^(00)+0?$|(^[0]+[0-9]+.?[0-9]$)/, newValue.substring(1));
    shiftedValue = Number(shiftedValue) === 0 ? '0' : shiftedValue;
    let correctPosition = 0;

    if (shiftedValue.length === 1) {
      shiftedValue = '00' + shiftedValue;
      correctPosition += 3;
    } else if (shiftedValue.length === 2) {
      shiftedValue = '0' + shiftedValue;
      correctPosition++;
    }

    const part1 = shiftedValue.substring(0, shiftedValue.length - 2);
    const part2 = shiftedValue.substring(shiftedValue.length - 2, shiftedValue.length);

    if (newCursorPosition > shiftedValue.length - 2) {
      correctPosition++;
    }
    let newFloatValue = '0.00';
    if (part1 && part2) {
      newFloatValue = part1 + '.' + part2;
    } else {
      correctPosition = 6;
    }
    const positionCorrected = newCursorPosition + correctPosition;

    return { newValue: newFloatValue, newCursorPosition: positionCorrected };
  }

  public setMask(
    value: string | number,
    cursorPosition
  ): { formatedValue; formatedCursorPosition } {
    if (!value) {
      return { formatedValue: '', formatedCursorPosition: 0 };
    }

    let valueString: string = typeof value === 'number' ? String(value.toFixed(2)) : value;

    const nagativeNumber: boolean = valueString.includes('-');
    if (nagativeNumber) valueString = valueString.replace('-', '');

    const distanceToFinal = valueString.length - cursorPosition;
    let correction = 0;

    let newValue = valueString.replace(/(^[\d]+)[.](\d{2})/g, this.replaceCurrency);

    let formatedCursorPosition = newValue.length;

    if (distanceToFinal > 2) {
      correction += 2;
      const distanceInteggerPart = distanceToFinal - 2;
      const triadsDigits = Math.floor(distanceInteggerPart / 3);
      correction += triadsDigits * 3;
    }

    formatedCursorPosition = newValue.length - (distanceToFinal + correction);

    if (nagativeNumber) newValue = '- ' + newValue;
    return { formatedValue: newValue, formatedCursorPosition };
  }

  private replaceCurrency(match: string, real: string, cent: string): string {
    let realFormt = real
      .split('')
      .reverse()
      .join('')
      .replace(/(\d{3})/g, '$1 . ')
      .split('')
      .reverse()
      .join('');
    realFormt = realFormt.replace(/^([ ][.][ ])/, '');
    return `R$ ${realFormt} , ${cent}`;
  }
}
